module.exports = __webpack_public_path__ + "static/media/08-textpage2.80e11ed7.png";